import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useGlobal } from '../contexts/global';
import { verificaEmail, descobreCidadePorHash } from '../services/Votacao';
import { getErrorMessage } from '../utils/errorHandler';
import { setApiCity } from '../plugins/axios';

const VerifyEmail = () => {
  const history = useHistory();
  const { hash } = useParams();
  const { setSuccess, setError } = useGlobal();

  useEffect(() => {
    let isCancelled = false;

    const processVerification = async () => {
      try {
        const cidadeDetectada = await descobreCidadePorHash(hash);

        if (isCancelled) return;

        if (!cidadeDetectada) {
          setError('Voto não encontrado ou link expirado.');
          history.push('/');
          return;
        }

        setApiCity(cidadeDetectada);
        sessionStorage.setItem('cidadeAtivaPage', `/${cidadeDetectada}`);

        await verificaEmail(hash);

        if (isCancelled) return;

        setSuccess(true);
        history.push(`/${cidadeDetectada}`);
      } catch (error) {
        if (isCancelled) return;

        const errorMsg = getErrorMessage(
          error,
          'Erro ao verificar o seu voto. Tente novamente mais tarde.'
        );
        setError(errorMsg);

        const fallbackCity = sessionStorage.getItem('cidadeAtivaPage') || '/';
        history.push(fallbackCity);
      }
    };

    if (hash) {
      processVerification();
    }

    return () => {
      isCancelled = true;
    };
  }, [hash, history, setSuccess, setError]);

  return <></>;
};

export default VerifyEmail;
